import { InformationIcon, PictureIcon } from '@/common/icons/general.tsx'
import { Card, CardContent } from '@/common/components/Card.tsx'
import AppDialog from '@/common/components/Dialog.tsx'
import { Button } from '@/common/components/Button.tsx'
import { Input } from '@/common/components/Input.tsx'
import { useState } from 'react'
import InformationPopover from '@/common/components/InformationPopover.tsx'
import { DatePicker } from '@/common/components/DatePicker.tsx'
import { WizardBodyContainer } from '@/app/pages/program_applications/vendor_application/components/WizardBodyContainer.tsx'
import { WizardFooter } from '@/app/pages/program_applications/vendor_application/components/WizardFooter.tsx'
import { WizardStepTitle } from '@/app/pages/program_applications/vendor_application/components/WizardStepTitle.tsx'
import { WizardStepContent } from '@/app/pages/program_applications/vendor_application/components/WizardStepContent.tsx'
import { useWizardContext } from '@/app/pages/program_applications/vendor_application/WizardProvider.tsx'
import { useTranslation } from 'react-i18next'

const DOCUMENTS = [
  {
    icon: <PictureIcon className="text-primary text-8xl" />,
    name: 'annual_compliance_review',
  },
  {
    icon: <PictureIcon className="text-primary text-8xl" />,
    name: 'proof_of_business_registry',
  },
  {
    icon: <PictureIcon className="text-primary text-8xl" />,
    name: 'tuition_and_fee_schedule',
  },
] as const

const StepId = 4 as const
export default function SupportingDocuments() {
  const { t: translate } = useTranslation()
  const { setStepCompleted, goNext } = useWizardContext()
  const [open, setOpen] = useState(false)
  const [date, setDate] = useState(new Date())
  const validateForm = () => {
    setStepCompleted(StepId)
    goNext()
  }
  return (
    <>
      <WizardBodyContainer>
        <WizardStepTitle>{translate('supporting_documents')}</WizardStepTitle>
        <WizardStepContent className="flex-grow flex flex-col">
          <p className="pl-8 mb-3 font-semibold">
            {translate('please_upload_the_following_required_documents')}
          </p>
          <p className="mb-10 pl-16 text-sm text-gray-500">
            {translate('for_more_information_please_reference')}&nbsp;
            <a
              className="text-primary font-medium"
              href="https://help.acescholarships.org"
              target="_blank"
            >
              {translate('qualifying_provider_handbook')}&nbsp;
            </a>
            {translate('and_the')}&nbsp;
            <a
              className="text-primary font-medium"
              href="https://docs.google.com/document/d/1LRsx0sDI9MfZ_3z1sIBw6Utk0oTeod3r/edit?usp=sharing&ouid=102876116478532234947&rtpof=true&sd=true?"
              target="_blank"
            >
              {translate('ufa_cpa_agreed_upon_procedures')}
            </a>
          </p>
          <div className="flex flex-col items-center md:flex-wrap sm:flex-row">
            {DOCUMENTS.map((doc) => (
              <div className="w-1/3 min-w-72 p-6">
                <Card
                  className="flex flex-col justify-between h-full cursor-pointer font-medium"
                  onClick={() => setOpen(!open)}
                >
                  <CardContent className="p-8">
                    <div className="flex flex-col items-center">
                      {doc.icon}
                      <p className="text-center p-6">{translate(doc.name)}</p>
                    </div>
                  </CardContent>
                </Card>
              </div>
            ))}
          </div>

          <AppDialog open={open} setOpen={setOpen} panelClassName="">
            <div className="flex flex-col mt-4">
              <label htmlFor="fileInput">
                <Card className="p-8 m-4 cursor-pointer">
                  <CardContent>
                    <Input type="file" id="fileInput" className="hidden" />
                    <div className="flex flex-col items-center justify-center h-full">
                      <p className="font-regular text-md text-center">
                        {translate('drag_and_drop_or')}
                        <span className="text-primary font-medium block">
                          {translate('browse_file')}
                        </span>
                      </p>
                    </div>
                  </CardContent>
                </Card>
              </label>
              <div className="mt-4 text-center">
                <label
                  htmlFor="expirationdate"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  {translate('document_expiration_date')}
                  <span className="text-danger ml-1">*</span>
                  <InformationPopover message="This is the expiration date of the document uploaded above">
                    <InformationIcon className="text-md ml-1" />
                  </InformationPopover>
                </label>
                <div className="mt-1">
                  <DatePicker
                    mode="single"
                    selected={date}
                    onOpenChange={setOpen}
                    onSelect={(date) => {
                      if (date) {
                        setDate(date)
                      }
                    }}
                    open={open}
                  />
                </div>
              </div>
              <div className="flex justify-center mt-6 space-x-4">
                <Button variant="outline" onClick={() => setOpen(false)}>
                  {translate('cancel')}
                </Button>
                <Button onClick={() => setOpen(false)}>
                  {translate('upload')}
                </Button>
              </div>
            </div>
          </AppDialog>
        </WizardStepContent>
      </WizardBodyContainer>
      <WizardFooter onNext={validateForm} />
    </>
  )
}
